import teamCodeHashmap from "utils/teamCodeHashmap";
import { getPublicAssetUrl } from "./getPublicAssetUrl";

export function getTeamCodeFromName(teamName) {
  if (!teamName) {
    return "";
  }

  const teamEntry = teamCodeHashmap[teamName.toLowerCase()];
  return teamEntry ? Object.keys(teamEntry)[0] : "";
}

export function getFlagImagePathFromCode(teamCode) {
  if (!teamCode) {
    return "";
  }

  return getPublicAssetUrl(
    `Retangular_flags/flag_${String(teamCode).trim().toLowerCase()}.png`
  );
}

export function getFlagImagePath(teamName) {
  return getFlagImagePathFromCode(getTeamCodeFromName(teamName));
}
